<div>
  <table>
    <thead>
      <tr>
        <th *ngFor="let title of titles">
          {{title}}
        </th>
      </thead>
    <tbody>
      <tr *ngFor="let item of itens">
        <td *ngFor="let one of item">
          <span [innerHTML]="one"></span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
